import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {
  Typography,
  TextField,
  InputAdornment,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  MenuItem,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
} from "@material-ui/core";
import "./Requisition.css";
import Autocompete from "../JobRequisition/Autocompete";
export default function Requisition() {
  const [open, setOpen] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
    <Dialog 
                    open={open} 
                    onClose={handleClose}
                    fullWidth
                    maxWidth="lg"
                >
                  <DialogContent>
                  <div class="Requisition" >

<h1>Create Requisition</h1>
<hr />
<div className="field-container">
  <div className="field-titles">
    Requester<span className="mandatory">*</span>
  </div>
  <div className="field-ans">
    
    <span className="work-h"></span><Autocompete/>
  </div>
</div>
<div className="field-container">
  <div className="field-titles">Currency</div>
  <div className="field-ans">
    <span className="mandatory">*</span>
    <Autocompete/>
  </div>
</div>
<div className="field-container">
  <div className="field-titles">Requisition Type</div>
  <div className="field-ans">
    <span className="mandatory">*</span>
    <Autocompete/>
  </div>
</div>
<div className="field-container">
  <div className="field-titles">Deliver-TO</div>
  <div className="field-ans">
    <span className="mandatory">*</span>
    <Autocompete/>
  </div>
</div>
<div className="field-container">
  <div className="field-titles">Ship-TO</div>
  <div className="field-ans">
    <span className="mandatory">*</span>
    <Autocompete/>
  </div>
</div>
<div className="field-container">
  <div className="field-titles">Worktags</div>
  <div className="field-ans">
    <span className="mandatory">*</span>
    <Autocompete/>
  </div>
</div>
<div className="button-div">
  <button className="ok-btn">Ok</button>
  <button className="cancel-btn">Cancel</button>
</div>
</div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                  </DialogActions>
                </Dialog>
     
    </>
  );
}
